<template>
  <div class="text-center fifth">
    <el-row class="hidden-sm-and-down">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        v-model:current-page="index.PageIndex"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </el-row>

    <el-row class="hidden-md-and-up">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../utils/gogocodeTransfer'
export default {
  name: 'CommonPage',
  data() {
    return {}
  },
  props: ['count', 'index'],
  mounted() {},
  watch: {
    $route(to, from) {
      if (to.query.IssueId && from.query.IssueId) {
        if (to.query.IssueId != from.query.IssueId) {
          $emit(this, 'pageindex', 1).index.PageIndex = 1
        } else {
          this.reload()
        }
      }
      if (to.query.Key && from.query.Key) {
        if (to.query.Key !== from.query.Key) {
          if (this.$route.query) {
            $emit(this, 'pageindex', 1).index.PageIndex = 1
          } else {
            this.reload()
          }
        }
      }
    },
  },
  methods: {
    handleSizeChange(val) {
      $emit(this, 'pageSize', val)
    },
    handleCurrentChange(val) {
      $emit(this, 'pageindex', val)
      window.scrollTo(0, 0)
    },
  },
  emits: ['pageindex', 'pageSize'],
}
</script>

<style scoped></style>
